import React from "react";
import buttonHelper from "@/helpers/buttonHelper";
import "./css/Button.css";

const Button = ({
  align,
  buttonClasses,
  buttonColor,
  buttonLarge,
  buttonsPositioning,
  filled = true,
  menu,
  page,
  news,
  concert,
  course,
  targetBlank,
  text,
  url,
  withinContainer,
  contentBefore,
}) => {
  let relatedPageLink = null;
  const buttonClassesApplied =
    buttonClasses && buttonColor
      ? buttonClasses.includes(buttonColor)
        ? buttonClasses
        : `${buttonClasses} tps-button-${buttonColor}`
      : buttonClasses
        ? buttonClasses
        : buttonColor
          ? `button ${
              buttonColor == "white"
                ? ""
                : `${filled === null || !!filled ? "tps-button-filled" : ""}` +
                  " tps-button-" +
                  buttonColor
            } ${buttonLarge ? " tps-large-button" : ""}`
          : "button fullWidthButton py-3 px-4";

  let target = !!url ? "_blank" : "_self";
  target =
    targetBlank === false ? "_self" : targetBlank === null ? target : "_blank";

  const href =
    url || buttonHelper.getLink({ page, news, concert, course }, menu);

  const element = (
    <>
      {!!contentBefore && (
        <div
          style={{ display: "inline" }}
          dangerouslySetInnerHTML={{ __html: contentBefore }}
        ></div>
      )}
      {align ? (
        <div style={{ textAlign: align ? align : "" }}>
          <a
            target={target}
            href={href}
            className={`${buttonClassesApplied}`}
            rel={target === "_blank" ? "noopener noreferrer" : undefined}
          >
            {text}
          </a>
          {buttonsPositioning == "in column" ? (
            <br />
          ) : buttonsPositioning == "in row" ? (
            <>&nbsp; &nbsp; &nbsp; </>
          ) : (
            ""
          )}
        </div>
      ) : (
        <>
          <a
            target={target}
            href={href}
            className={`${buttonClassesApplied}`}
            rel={target === "_blank" ? "noopener noreferrer" : undefined}
          >
            {text}
          </a>
          {buttonsPositioning == "in column" ? (
            <br />
          ) : (
            buttonsPositioning == "in row" && <>&nbsp; &nbsp; &nbsp; </>
          )}
        </>
      )}
    </>
  );

  return withinContainer ? (
    <div className={"grid-container"}>{element}</div>
  ) : (
    element
  );
};

export default Button;
